// extracted by mini-css-extract-plugin
module.exports = {"background":"CheckoutSideCreditCard_background__l72bA","headLine":"CheckoutSideCreditCard_headLine__yJNCS","featuresList":"CheckoutSideCreditCard_featuresList__N2hRU"};